export enum OcbLocalAgentCommandStatus {
    Waiting = 0,
    Running = 1,
    Done = 2,
    Error = 3,
    Expired = 4
}
